import { render, staticRenderFns } from "./EditEmployeeRatio.vue?vue&type=template&id=8d5ecb5c&scoped=true&"
import script from "./EditEmployeeRatio.vue?vue&type=script&lang=js&"
export * from "./EditEmployeeRatio.vue?vue&type=script&lang=js&"
import style0 from "./EditEmployeeRatio.vue?vue&type=style&index=0&id=8d5ecb5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5ecb5c",
  null
  
)

export default component.exports